<template>

	<div :class="{'page-message': true, invert: invert, flash: flash}">

		<h2 class="heading" v-html="title" v-if="title!==''" />

		<p><slot /></p>

	</div>

</template>

<script>
export default {
	name: 'PageMessage',
	props: {
		title: {
			type: String,
			default: ''
		},
		invert: {
			type: Boolean,
			default: false
		},
		flash: {
			type: Boolean,
			default: false
		}
	},
	computed: {},
	mounted() {
	},
	methods: {
	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_settings.less';
.page-message {
	background-color: #fff;
	padding: 20px;
	color: @darkContrast;
	.heading {
		font-size: 20px;
    	margin-bottom: 5px;
	}
	p {
		padding:0;
		margin: 0 0 20px;
		&:last-child {
			margin: 0;
		}
	}
	.heading, p, a, span {
		color: inherit;
	}

	&.invert {
		background-color: @darkContrast;
		color: #fff;
	}

	&.flash {
		position: relative;
		overflow: hidden;
		border-radius: 8px;
		
		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: -100%;
			width: 100%;
			height: 100%;
			background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
			animation: shimmer 3s ease-in-out infinite;
			z-index: 1;
		}
		
		.heading, p {
			position: relative;
			z-index: 2;
		}
	}
}

@keyframes shimmer {
	0% {
		left: -100%;
	}
	100% {
		left: 100%;
	}
}
</style>